var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductivityimg15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "url(#paint0_linear_852_1281)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "url(#paint1_linear_852_1281)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_852_1281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5263 29.4736L41.0527 28.421L29.4737 29.4736L28.4209 40L29.4735 50.5264L39.9999 51.8422L50.5263 50.5264L51.5789 39.737L50.5263 29.4736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7921 45.8052C33.0053 45.2736 32.4605 44.4974 32.1631 43.471L33.9895 42.7184C34.1553 43.35 34.4447 43.8394 34.8579 44.1868C35.2685 44.5342 35.7685 44.7052 36.3527 44.7052C36.9501 44.7052 37.4633 44.5236 37.8921 44.1604C38.3209 43.7972 38.5369 43.334 38.5369 42.7736C38.5369 42.2 38.3105 41.7314 37.8579 41.3684C37.4053 41.0054 36.8369 40.8236 36.1579 40.8236H35.1027V39.0158H36.0499C36.6341 39.0158 37.1263 38.858 37.5263 38.5422C37.9263 38.2264 38.1263 37.7948 38.1263 37.2448C38.1263 36.7554 37.9473 36.3658 37.5895 36.0738C37.2317 35.7818 36.7789 35.6344 36.2289 35.6344C35.6921 35.6344 35.2657 35.7766 34.9499 36.0634C34.6341 36.3502 34.4051 36.7028 34.2605 37.1186L32.4527 36.366C32.6921 35.687 33.1317 35.087 33.7763 34.5686C34.4211 34.0502 35.2447 33.7896 36.2447 33.7896C36.9841 33.7896 37.6499 33.9318 38.2395 34.2186C38.8289 34.5054 39.2921 34.9028 39.6263 35.408C39.9605 35.9158 40.1263 36.4844 40.1263 37.1158C40.1263 37.7606 39.9711 38.3052 39.6605 38.7526C39.3499 39.2 38.9683 39.542 38.5157 39.7816V39.8894C39.1002 40.1303 39.6078 40.5261 39.9841 41.0342C40.3657 41.5474 40.5577 42.1606 40.5577 42.8764C40.5577 43.5922 40.3761 44.2316 40.0129 44.7922C39.6497 45.3528 39.1471 45.7948 38.5103 46.1158C37.8709 46.4368 37.1525 46.6 36.3551 46.6C35.4315 46.6026 34.5789 46.3368 33.7921 45.8052ZM44.9999 36.7422L43.0051 38.1922L42.0025 36.6712L45.5999 34.0764H46.9789V46.3158H44.9999V36.7422Z",
    fill: "#9A9AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5266 59.9999L60.0002 50.5263L55.2634 48.4211L50.5266 50.5263L48.4214 55.2631L50.5266 59.9999Z",
    fill: "#D9D9E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3682 55.2632L29.4734 60H50.526V50.5264H29.4734L27.3682 55.2632Z",
    fill: "#A6A6C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1578 20C21.4132 20 20 21.4132 20 23.1578V50.5262L24.7368 52.6314L29.4736 50.5262V29.4736H50.5262L52.6314 24.7368L50.5264 20H23.1578Z",
    fill: "#C0C0D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 50.5264V56.8422C20 58.587 21.4132 60 23.1578 60H29.4736V50.5264H20Z",
    fill: "#8181B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5264 29.4736V50.5262H60V29.4736L55.2632 27.3684L50.5264 29.4736Z",
    fill: "#CCCCE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 29.4736V23.1578C60 21.413 58.5868 20 56.8422 20H50.5264V29.4736H60Z",
    fill: "#8D8DB9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_852_1281",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05050F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8DB9",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_852_1281",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27273F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_852_1281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductivityimg15);
export default __webpack_public_path__ + "static/media/productivityimg15.4a68636ef029ad8592018913b224ee6f.svg";
export { ForwardRef as ReactComponent };